let nativeShareFailed = false;

const canUseNativeShare = () => !nativeShareFailed && window.navigator.share;

const nativeShare = (shareData) => {
  return navigator.share(shareData).catch((e) => {
    if (!(e instanceof DOMException) || e.code !== 20) {
      console.error("Native share failed", e); // eslint-disable-line
      nativeShareFailed = true;
    }
  });
};

export { canUseNativeShare, nativeShare };
